import { modalMessages } from 'apps/web_forms/utils/constants';
import Modal from 'apps/web_forms/components/commons/Modal';

export const CopyDraftSuccessModal = ({resetSelectedModal, extraProps}) => {
  return (
    <Modal
      mainMessage={modalMessages.draftCopySuccess.main}
      helpTip={modalMessages.draftCopySuccess.tip}
      isOpen={true}
      setIsOpen={resetSelectedModal}
      icon='success'
    />
  );
};
